/* eslint-disable indent */
import {
  CREATE_MANUAL_VERIFIFCATION_CLAIM,
  GET_MANUAL_VERIFICATION_CAPTURED_NETWORK_REQUESTS,
  GET_MANUAL_VERIFICATION_PROVIDER_VERIFICATION_URL,
} from '../constants';
import { getFirebaseIdToken } from '../utils';

export const getManualVerifcationCapturedNetworkRequests = async (sessionId: string) => {
  try {
    const accessToken = await getFirebaseIdToken();
    const response = await fetch(
      GET_MANUAL_VERIFICATION_CAPTURED_NETWORK_REQUESTS(sessionId),
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getManualVerifcationProviderVerificationUrl = async (
  providerId: string,
  paramsAdded: Record<string, string>
) => {
  try {
    const accessToken = await getFirebaseIdToken();
    const response = await fetch(GET_MANUAL_VERIFICATION_PROVIDER_VERIFICATION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        paramsAdded: paramsAdded || {},
        providerId,
      }),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createManualVerificationClaimData = async (
  providerId: string,
  paramValues: any
) => {
  try {
    const accessToken = await getFirebaseIdToken();
    const payload = {
      httpProviderId: providerId,
      paramValues,
    };
    const response = await fetch(CREATE_MANUAL_VERIFIFCATION_CLAIM(providerId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return { isSuccess: false, data: null, message: 'something went wrong' };
  }
};
